/* Comportamenti della demo di Claude Design portati nel tema:
   intestazione che si compatta, menu del telefono, parallasse delle bande,
   carosello delle citazioni, fasce orarie del modulo di prenotazione.
   Tutto è opzionale: se un pezzo non è in pagina, viene semplicemente saltato. */
(function () {
  /* Il file e' incluso da OGNI sezione `nb-*`: sulla home il tag compare 6 volte e il
     browser esegue ogni tag, non una volta sola. Senza questa guardia i listener si
     moltiplicavano — il click sull'hamburger faceva 6 `toggle` (numero pari) e il menu
     del telefono non si apriva, e il carosello delle citazioni si ritrovava 18 punti
     invece di 3. Misurato il 2026-08-22. */
  if (window.__nbDemoAvviato) { return; }
  window.__nbDemoAvviato = true;

  var ridotto = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Heritage non fa scorrere il documento: sopra i 990px lo scorrimento avviene
     dentro `.page-wrapper`. Qui si individua l'elemento che scorre davvero. */
  function scroller() {
    var w = document.querySelector('.page-wrapper');
    if (w) {
      var ov = getComputedStyle(w).overflowY;
      if (ov === 'auto' || ov === 'scroll') return w;
    }
    return null;
  }
  var box = scroller();
  var sorgente = box || window;
  function quanto() { return box ? box.scrollTop : window.scrollY; }

  /* ---- intestazione e menu ---- */
  var header = document.getElementById('header');
  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  if (burger && drawer && header) {
    burger.addEventListener('click', function () {
      header.classList.toggle('open');
      drawer.classList.toggle('open');
    });
    document.querySelectorAll('.drawerLink').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('open');
        drawer.classList.remove('open');
      });
    });
  }

  /* ---- parallasse ---- */
  var hero = document.querySelector('[data-nb-parallax="hero"]');
  var bande = [].slice.call(document.querySelectorAll('[data-nb-parallax="banda"]'));

  /* Quanto l'immagine puo' spostarsi senza scoprire il fondo nero: si ricava
     dalla geometria vera (l'immagine sborda dalla sezione sopra e sotto), non da
     una percentuale scritta a mano — le sezioni usano sbordi diversi. `t` e' lo
     spostamento gia' applicato, che va tolto per tornare alla posizione a riposo. */
  function estremi(el, sezione, t) {
    var a = el.getBoundingClientRect();
    var b = sezione.getBoundingClientRect();
    var giu = Math.floor(b.top - (a.top - t));
    var su = Math.ceil(b.bottom - (a.bottom - t));
    return [Math.min(0, su), Math.max(0, giu)];
  }

  function applicaA(el, sezione, valore) {
    var t = parseFloat((/translateY\((-?[\d.]+)px\)/.exec(el.style.transform) || [0, 0])[1]) || 0;
    var e = estremi(el, sezione, t);
    el.style.transform = 'translateY(' + Math.max(e[0], Math.min(e[1], valore)) + 'px)';
  }

  function scostamento(sezione) {
    var r = sezione.getBoundingClientRect();
    return Math.round((r.top - window.innerHeight * 0.5) * -0.5);
  }

  var inCoda = false;
  function applica() {
    inCoda = false;
    if (header) header.classList.toggle('scrolled', quanto() > 40);
    if (ridotto) return;
    if (hero) {
      applicaA(hero, hero.closest('section') || hero.parentElement, Math.round(quanto() * 0.18));
    }
    bande.forEach(function (img) {
      var sez = img.closest('section') || img.parentElement;
      applicaA(img, sez, scostamento(sez));
    });
  }
  function alloScorrimento() {
    if (!inCoda) { inCoda = true; requestAnimationFrame(applica); }
  }
  /* in fase di cattura sul documento: prende sia lo scorrimento della pagina sia
     quello del contenitore interno di Heritage, qualunque dei due sia attivo */
  document.addEventListener('scroll', alloScorrimento, { capture: true, passive: true });
  window.addEventListener('resize', function () { box = scroller(); applica(); }, { passive: true });
  applica();

  /* ---- carosello delle citazioni ---- */
  var testo = document.getElementById('quoteText');
  var fonte = document.getElementById('quoteSource');
  var punti = document.getElementById('quoteDots');
  if (testo && punti) {
    var citazioni = [];
    try { citazioni = JSON.parse(punti.dataset.citazioni || '[]'); } catch (e) { citazioni = []; }
    if (citazioni.length) {
      citazioni.forEach(function (q, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dotBtn';
        /* l'etichetta arriva dal Liquid (locales), altrimenti resterebbe italiana su /en e /fr */
        b.setAttribute('aria-label', (punti.dataset.etichetta || 'Recensione') + ' ' + (i + 1));
        b.addEventListener('click', function () { mostra(i); });
        punti.appendChild(b);
      });
      var indice = 0;
      function mostra(i) {
        indice = i;
        testo.textContent = '“' + citazioni[i].testo + '”';
        if (fonte) fonte.textContent = citazioni[i].fonte || '';
        [].forEach.call(punti.children, function (el, idx) { el.classList.toggle('active', idx === i); });
      }
      mostra(0);
      if (citazioni.length > 1 && !ridotto) {
        var giro = setInterval(function () { mostra((indice + 1) % citazioni.length); }, 7000);
        punti.addEventListener('click', function () { clearInterval(giro); });
      }
    }
  }

  /* ---- fasce orarie del modulo ---- */
  var riga = document.getElementById('slotRow');
  if (riga) {
    var campo = document.getElementById('slotValue');
    [].forEach.call(riga.querySelectorAll('.slotBtn'), function (b) {
      b.addEventListener('click', function () {
        [].forEach.call(riga.querySelectorAll('.slotBtn'), function (el) { el.classList.remove('active'); });
        b.classList.add('active');
        if (campo) campo.value = b.textContent.trim();
      });
    });
  }
})();
